import { LOCALES } from "@uzverse/core";
import i18next from "i18next";
import { commonMessages } from "./common.js";
export { LOCALES };
export const DEFAULT_LOCALE = "tr";
export const FALLBACK_LOCALE = "en";
/**
 * Declares a namespace of UI strings in every supported locale. Each package or module owns its
 * own namespace (e.g. "identity", "org"), so nobody edits a shared file to add strings.
 */
export function defineMessages(namespace, messages) {
    if (!/^[a-z][a-zA-Z0-9-]*$/.test(namespace)) {
        throw new Error(`invalid i18n namespace '${namespace}'`);
    }
    return { namespace, messages: messages };
}
/** Dotted keys present in `a` but missing (or not a string) in `b`. */
export function missingKeys(a, b, prefix = "") {
    const out = [];
    for (const [key, value] of Object.entries(a)) {
        const path = prefix ? `${prefix}.${key}` : key;
        const other = b[key];
        if (typeof value === "string") {
            if (typeof other !== "string" || other.length === 0)
                out.push(path);
        }
        else if (!other || typeof other === "string") {
            out.push(path);
        }
        else {
            out.push(...missingKeys(value, other, path));
        }
    }
    return out;
}
/** Keys missing in any locale of a bundle, relative to every other locale. */
export function bundleParityErrors(bundle) {
    const errors = [];
    for (const a of LOCALES) {
        for (const b of LOCALES) {
            if (a === b)
                continue;
            for (const key of missingKeys(bundle.messages[a], bundle.messages[b])) {
                errors.push(`${bundle.namespace}:${key} missing in '${b}'`);
            }
        }
    }
    return errors;
}
/** Creates an isolated, synchronously initialized i18next instance. */
export function createI18n(options) {
    const bundles = [commonMessages, ...(options.bundles ?? [])];
    const resources = {};
    for (const locale of LOCALES) {
        resources[locale] = {};
        for (const b of bundles)
            resources[locale][b.namespace] = b.messages[locale];
    }
    const instance = i18next.createInstance();
    void instance.init({
        lng: options.locale,
        fallbackLng: FALLBACK_LOCALE,
        supportedLngs: [...LOCALES],
        ns: bundles.map((b) => b.namespace),
        defaultNS: "common",
        resources,
        initAsync: false,
        returnNull: false,
        interpolation: { escapeValue: false },
    });
    return instance;
}
/** Picks a supported locale from an Accept-Language style list. */
export function negotiateLocale(preferred) {
    const list = typeof preferred === "string" ? preferred.split(",") : (preferred ?? []);
    for (const raw of list) {
        const tag = raw.trim().split(";")[0].toLowerCase().split("-")[0];
        const hit = LOCALES.find((l) => l === tag);
        if (hit)
            return hit;
    }
    return DEFAULT_LOCALE;
}
export { commonMessages };
//# sourceMappingURL=index.js.map